import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { UserAuthService } from '../../services/user-auth.service';

@Component({
  selector: 'app-user-login',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.scss']
})
export class UserLoginComponent {
  // Login form
  email = '';
  password = '';
  
  // OTP form
  otpCode = '';
  showOtpForm = false;
  
  // State
  loading = false;
  error = '';

  constructor(
    private apiService: ApiService,
    private authService: UserAuthService,
    private router: Router
  ) {}

  onLogin(): void {
    if (!this.email || !this.password) {
      this.error = 'Please enter email and password';
      return;
    }

    this.loading = true;
    this.error = '';

    this.apiService.userLogin({ email: this.email, password: this.password }).subscribe({
      next: () => {
        this.loading = false;
        this.showOtpForm = true;
      },
      error: (err) => {
        this.loading = false;
        this.error = err.error?.error || 'Login failed. Please try again.';
      }
    });
  }

  onVerifyOtp(): void {
    if (!this.otpCode || this.otpCode.length !== 6) {
      this.error = 'Please enter a valid 6-digit OTP code';
      return;
    }

    this.loading = true;
    this.error = '';

    this.apiService.verifyOtp({ email: this.email, otpCode: this.otpCode }).subscribe({
      next: (response) => {
        this.loading = false;
        this.authService.setSession(response.user, response.expiresAt);
        this.router.navigate(['/welcome']);
      },
      error: (err) => {
        this.loading = false;
        this.error = err.error?.error || 'Invalid OTP code. Please try again.';
      }
    });
  }

  onResendOtp(): void {
    this.loading = true;
    this.error = '';

    this.apiService.resendOtp(this.email).subscribe({
      next: () => {
        this.loading = false;
        this.error = 'A new OTP has been sent to your email.';
      },
      error: (err) => {
        this.loading = false;
        this.error = err.error?.error || 'Failed to resend OTP.';
      }
    });
  }

  onBackToLogin(): void {
    this.showOtpForm = false;
    this.otpCode = '';
    this.error = '';
  }
}

